import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { getPaneZIndex } from 'app/containers/Map/slice/helpers';
import { FIELDS_LAYER_ID } from 'app/containers/Map/slice/map-constants';
import { selectSelectedSeasonId } from 'app/containers/Season/slice/selectors';
import React, { FC, useEffect } from 'react';
import { Pane, useMap } from 'react-leaflet';
import { WMSTileLayer } from 'react-leaflet';
import { useSelector } from 'react-redux';
import { API_URL } from 'utils/constants';
import {
  selectLayers,
  selectVisibleWmsTileLayers,
} from '../../../slice/selectors';

interface IProps {}

const useLayersZIndex = () => {
  const map = useMap();
  const layers = useSelector(selectLayers);
  useEffect(() => {
    if (map) {
      layers.forEach((layer, index) => {
        if (layer.id === FIELDS_LAYER_ID) {
          const markersPane = map.getPane('markerPane');
          const overlayPane = map.getPane('overlayPane');
          if (markersPane && overlayPane) {
            const zIndex = String(getPaneZIndex(index));

            overlayPane.style.zIndex = zIndex;
            markersPane.style.zIndex = zIndex;
          }
        } else {
          const layerPane = map.getPane(layer.id);
          const zIndex = String(getPaneZIndex(index));
          if (layerPane) {
            layerPane.style.zIndex = zIndex;
          }
        }
      });
    }
  }, [map, layers]);
};

const WmsTileLayers: FC<IProps> = () => {
  useLayersZIndex();

  const layers = useSelector(selectVisibleWmsTileLayers);
  const envId = useSelector(selectSelectedEnvId);
  const seasonId = useSelector(selectSelectedSeasonId);

  const wmsOptions = {
    service: 'WMS',
    version: '1.1.0',
    request: 'GetMap',
    layer_preview: true,
    format: 'image/png',
    hiiko_environment_id: envId,
    season_id: seasonId,
  };

  return (
    <>
      {layers.map(layer => {
        console.log(`layerID: ${layer.id} - layerIndex: ${layer.index}`);
        return (
          <Pane
            name={layer.id}
            style={{ zIndex: getPaneZIndex(layer.index) }}
            key={layer.id}
          >
            <WMSTileLayer
              key={layer.id}
              url={`${API_URL}/geoserver/wms?`}
              params={{ ...wmsOptions, layers: layer.layers || '' }}
              format="image/png"
              opacity={layer.opacity}
              transparent={true}
            />
          </Pane>
        );
      })}
    </>
  );
};

export default WmsTileLayers;
